import PaymentHandlingDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/PrimerPaymentHandlingDescriptionIos.mdx";
import ManualFlowDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/ManualFlowDescriptionIos.mdx";
import LanguageCodeDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/LanguageCodeDescriptionIos.mdx";
import RegionCodeDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/RegionCodeDescriptionIos.mdx";
import UrlSchemeDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/UrlSchemeDescriptionIos.mdx";
import ApplePayDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/ApplePayDescriptionIos.mdx";
import CaptureBillingAddressDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/CaptureBillingAddressDescriptionIos.mdx";
import ApplePayUnsupportedDeviceDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/ApplePayForUnsupportedDevice.mdx";
import ApplePayCheckNetworksDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/ApplePayCheckNetworks.mdx";
import KlarnaDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/KlarnaDescriptionIos.mdx";
import UiOptionsDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/UiOptionsDescriptionIos.mdx";
import InitScreenEnabledDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/InitScreenEnabledDescriptionIos.mdx";
import SuccessScreenEnabledDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/SuccessScreenEnabledDescriptionIos.mdx";
import ErrorScreenEnabledDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/ErrorScreenEnabledDescriptionIos.mdx";
import ThreeDsOptionsIos from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/ThreeDsOptionsIos.mdx";
import StripeOptionsIoS from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/StripeOptionsIos.mdx";
import ApplePayMerchantNameIOS from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/ApplePayMerchantNameIOS.mdx";
import ClientSessionCachingEnabled from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/ClientSessionCachingEnabled.mdx";
import PrimerApiVersionDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/PrimerApiVersionDescription.mdx";
import DropInDismissalMechanismDescription from "../../../../content/sdk/ios/2.x.x/_common/_descriptions/DropInDismissalMechanismDescription.mdx";
import * as React from 'react';
export default {
  PaymentHandlingDescription,
  ManualFlowDescription,
  LanguageCodeDescription,
  RegionCodeDescription,
  UrlSchemeDescription,
  ApplePayDescription,
  CaptureBillingAddressDescription,
  ApplePayUnsupportedDeviceDescription,
  ApplePayCheckNetworksDescription,
  KlarnaDescription,
  UiOptionsDescription,
  InitScreenEnabledDescription,
  SuccessScreenEnabledDescription,
  ErrorScreenEnabledDescription,
  ThreeDsOptionsIos,
  StripeOptionsIoS,
  ApplePayMerchantNameIOS,
  ClientSessionCachingEnabled,
  PrimerApiVersionDescription,
  DropInDismissalMechanismDescription,
  React
};